import {
  Text,
  type ComboboxItem,
  type ComboboxLikeRenderOptionInput,
  type OptionsFilter,
} from "@mantine/core";

export interface IcdCodeComboboxItem extends ComboboxItem {
  fullLabel: string;
}

export const filterIcdCodeOptions: OptionsFilter = ({ options, search }) => {
  const normalizedSearch = search.trim().toLowerCase();
  if (!normalizedSearch) return options;

  return options.filter((option) => {
    if ("group" in option) return false;
    const icdOption = option as IcdCodeComboboxItem;
    return icdOption.fullLabel.toLowerCase().includes(normalizedSearch);
  });
};

export function IcdCodeSelectOption({
  option,
}: ComboboxLikeRenderOptionInput<ComboboxItem>) {
  const fullLabel = (option as IcdCodeComboboxItem).fullLabel ?? option.label;

  return (
    <Text size="xs" style={{ whiteSpace: "normal" }}>
      {fullLabel}
    </Text>
  );
}
